import {useSelectedAssetsDispatch} from "../../contexts/SelectedAssetsContext";
import {useLoadedAssetsDispatch} from "../../contexts/LoadedAssetsContext";

export default ()=>{
    const loadedAssetsDispatch = useLoadedAssetsDispatch()

    return ()=> {
        loadedAssetsDispatch({type:'reload'})
    }
}